import { lazy } from 'react'

const exportable = {}

exportable.Homeowner = lazy(() => import('src/features/homeowners/Routes' /* webpackChunkName: "homeowner" */))
exportable.Buyer = lazy(() => import('src/features/buyers/Routes' /* webpackChunkName: "buyer" */))
exportable.ZipCodeModal = lazy(
  () => import('src/Components/buyers/Global/ZipCodeModal' /* webpackChunkName: "ZipCodeModal" */)
)

export default exportable
